/* eslint-disable no-unused-vars */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CheckInBranchPage from './pages/CheckInBranchPage';
import CheckinBranchSummaryPage from './pages/CheckinBranchSummaryPage';
import CheckinUserPage from './pages/CheckinUserPage';
import CheckinUserHistoryPage from './pages/CheckinUserHistoryPage';

const queryClient = new QueryClient();

export default ({ match }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Switch>
        <Route
          path={`${match.path}/branch/:branchId`}
          exact
          children={<CheckinBranchSummaryPage />}
        />
        <Route
          path={`${match.path}/branch`}
          exact
          children={<CheckInBranchPage />}
        />
        <Route
          path={`${match.path}/user/:userId`}
          exact
          children={<CheckinUserHistoryPage />}
        />
        <Route
          path={`${match.path}/user`}
          exact
          children={<CheckinUserPage />}
        />
      </Switch>
    </QueryClientProvider>
  );
};
